import { Component, OnInit } from '@angular/core';
import { ShuttleComponent } from '../shuttle/shuttle.component';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";
import { shuttleService } from '../data/shuttle.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-shuttle-deactivate',
  templateUrl: './shuttle-deactivate.component.html',
  styleUrls: ['./shuttle-deactivate.component.css'],

})
export class ShuttleDeactivateComponent extends ShuttleComponent implements OnInit {

     constructor(private c_cookieService:CookieService,private c_router: Router, private c_shuttleService:shuttleService,private c_location:Location) {
          super(c_cookieService,c_router,c_shuttleService,c_location);
          console.log('shuttle deactivate constructor');

     }

  ngOnInit() {
       super.ngOnInit();
  }

}
